import {useTheme} from '@mui/material';
import {QueryParamsEnum} from 'presentation/constants';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useMediaQueries, useQueryParams} from 'presentation/pages';
import {UseTelehealthDuplicityDialogProps} from './types';

import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {TELEMEDICINE_INFO} from 'presentation/modules/booking/shared/constants/telemedicineInfo';
import {getTelehealthStepPosition} from 'presentation/modules/booking/telehealth/utils/getTelehealthStepPosition';
import {translations} from 'presentation/translations-new';

const {
	headerTitle: duplicityHeaderTitle,
	teleHeaderTitle,
	teleDescription,
	description: duplicityDescription,
} = translations['pt-br'].privateFlow.bookingFlow.duplicityWarning;

function useTelehealthDuplicityDialog({
	scheduledBooking,
	setOpen,
}: UseTelehealthDuplicityDialogProps) {
	const setBookingData = useBookingStore(state => state.setBookingData);
	const setActiveBookingFlowStep = useBookingFlowStepsStore(state => state.setBookingStep);
	const {isMobile} = useMediaQueries();
	const {colors} = useTheme();
	const {setSearchParams} = useQueryParams();

	const bookingTypeIsTelemedicine = scheduledBooking.bookingType === BookingTypeEnum.TELEHEALTH;

	const contentTitle = bookingTypeIsTelemedicine ? teleHeaderTitle : duplicityHeaderTitle;
	const contentDescription = bookingTypeIsTelemedicine ? teleDescription : duplicityDescription;

	const handleSwapSpecialty = async () => {
		const {PROFESSIONAL_STEP} = getTelehealthStepPosition();

		setActiveBookingFlowStep(PROFESSIONAL_STEP);

		setBookingData(prev => ({
			...prev,
			specialtyCode: scheduledBooking.specialtyCode,
			subSpecialtyCode:
				!scheduledBooking.subSpecialtyCode || scheduledBooking.subSpecialtyCode === '0'
					? ''
					: scheduledBooking.subSpecialtyCode,
			specialtyName: scheduledBooking.specialtyNameSelected ?? scheduledBooking.specialtyName,
			bookingNumber: scheduledBooking.bookingNumber,
			isRebooking: true,
			isScheduleScript: false,
			districtName: undefined,
			citiesNames: undefined,
			hasGeoDistrictsFilter: false,
			unitCode: TELEMEDICINE_INFO.code,
			unitName: TELEMEDICINE_INFO.name,
		}));

		setSearchParams(prev => {
			prev.delete(QueryParamsEnum.SEARCH_QUERY);
			return prev;
		});
	};

	const handeClose = () => {
		setOpen(false);
	};

	const alertModalPaperProps = {
		maxWidth: isMobile ? '100%' : 450,
		borderRadius: isMobile ? 0 : 8,
		margin: isMobile ? 0 : 16,
		backgroundColor: isMobile ? colors.gray['20Percent'] : undefined,
	};

	return {
		handleSwapSpecialty,
		colors,
		isMobile,
		handeClose,
		alertModalPaperProps,
		contentTitle,
		contentDescription,
	};
}

export {useTelehealthDuplicityDialog};
